import React from 'react';
import cn from 'classnames';

import styles from './tabular-grid-for-key-element-display.module.css';

export type RowCellData = {
  label: string,
  value: React.ReactNode,
};

interface RowCellProps {
  label: string;
  value: React.ReactNode;
}

const RowCell: React.FC<RowCellProps> = ({ label, value }) => {
  return (
    <div className={cn(styles.rowCell, styles.rowCellGap)}>
      <div className={cn(styles.cellKey, styles.label)}>{label}</div>
      <div className={cn(styles.cellValue)}>{value}</div>
    </div>
  );
};

interface RowProps {
  rowData: RowCellData[];
}

const Row: React.FC<RowProps> = ({ rowData }) => {
  return (
    <div className={cn(styles.row, styles.rowGap)}>
      {rowData.map((cellData, index) => (
        <RowCell key={index} label={cellData.label} value={cellData.value} />
      ))}
    </div>
  );
};

interface GridData {
  data: RowCellData[];
}

const TabularGridForKeyElementDisplay: React.FC<GridData> = ({ data }) => {
  const numberOfCellsPerRow = 2;
  const dataLength = data.length;
  const rows: RowCellData[][] = [];
  let row: RowCellData[] = [];
  
  data.forEach((cellData, index) => {
    const isRowEnd = index % numberOfCellsPerRow === 0;
    if (isRowEnd && index != 0) {
      rows.push(row);
      row = [];
    }
    row.push(cellData);

    if (index === dataLength - 1) {
      rows.push(row);
    }
  });

  return (
    <div className={cn(styles.pageContainer)}>
      {rows.map((rowData, index) => (
        <Row key={index} rowData={rowData} />
      ))}
    </div>
  );
};

export default TabularGridForKeyElementDisplay;
